module.exports = function isNull(obj){return obj === null;}


/*****************
 ** WEBPACK FOOTER
 ** ./lib/isNull.js
 ** module id = 9
 ** module chunks = 0
 **/